// extracted by mini-css-extract-plugin
export default {"label":"product-set-description__label___1Vvmp"};